import { get } from 'axios'
import store from './../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization: `Bearer ${store.state.user.attributes.token}` }

//get
function getPostulantContractPayments (pPostulantId) {
    const URI = `${BASE_URL}/api/postulants/${pPostulantId}/contractPayments`
    return get(URI, { headers })
}

export { getPostulantContractPayments }